import React from "react";
import { Row } from "react-bootstrap";
import { NoEventsFound } from "./EventsPanelParts";
import "../eventPanel.css";
import ArchiveEventCard from "./ArchiveEventCard";

export function ArchiveEventsPanel({ events }) {
  return (
    <section className="px-2 mb-5">
      <Row className="mx-n2">
        {events.map((event) => (
          <ArchiveEventCard key={event.eventId} {...event} />
        ))}
        {!events?.length && <NoEventsFound />}
      </Row>
    </section>
  );
}
